import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import TransHistory from 'view/transHistory';

const TransHistoryPage = () => {
	return (
		<PageTemplate>
			<TransHistory />
		</PageTemplate>
	);
};

export default TransHistoryPage;

 